import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const SearchOutline: React.FC<IconComponentProps> = ({
  className,
  strokeWidth = '1.5',
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.393 19.2321C15.2748 19.2321 19.2323 15.2747 19.2323 10.3928C19.2323 5.51104 15.2748 1.55356 10.393 1.55356C5.51119 1.55356 1.55371 5.51104 1.55371 10.3928C1.55371 15.2747 5.51119 19.2321 10.393 19.2321Z"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.4469 22.4464L16.6436 16.6431"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
